import { ArrowIcon } from "../../../assets/img/svg/ArrowIcon";
import { Button } from "../Button/Button";
import { addStyles } from "./addStyles";

// import { IconSprite } from "../IconSprite/IconSprite";

export const StepButton = ({ className, direction = "right", ...rest }) => {
  return (
    <Button
      className={className}
      {...rest}
      styles={addStyles(direction)}
      color="secondary"
    >
      <ArrowIcon />
      {/* <IconSprite tag="arrow" width="24" height="25" /> */}
    </Button>
  );
};
